export default __webpack_public_path__ + "static/media/chim5.e5c8da27.webp";